import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, unref as _unref, isRef as _isRef, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "shift__head" }
const _hoisted_2 = {
  key: 0,
  class: "shift__content"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "shift__form"
}
const _hoisted_5 = { class: "shift__inputs" }
const _hoisted_6 = {
  key: 0,
  class: "shift__times-break"
}
const _hoisted_7 = {
  key: 1,
  class: "shift__error"
}
const _hoisted_8 = {
  key: 1,
  class: "shift__vacation-row"
}
const _hoisted_9 = { class: "shift__vacation-title" }
const _hoisted_10 = {
  key: 0,
  class: "shift__error-wrap"
}
const _hoisted_11 = {
  key: 0,
  class: "shift__error-wrap"
}
const _hoisted_12 = {
  key: 1,
  class: "shift__error-wrap"
}
const _hoisted_13 = {
  key: 2,
  class: "shift__error-wrap"
}
const _hoisted_14 = {
  key: 2,
  class: "shift__vacation-add"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 3,
  class: "shift__times"
}
const _hoisted_17 = ["data-editable"]
const _hoisted_18 = {
  key: 0,
  class: "shift__times-date"
}
const _hoisted_19 = { class: "shift__times-time" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "time" }
const _hoisted_22 = {
  key: 0,
  class: "editing-fields"
}
const _hoisted_23 = {
  key: 1,
  class: "editing-fields"
}
const _hoisted_24 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "shift__times-item-close" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 0,
  class: "shift__menu"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 1,
  class: "shift__times-break"
}
const _hoisted_31 = {
  key: 2,
  class: "shift__times-break"
}
const _hoisted_32 = {
  key: 3,
  class: "shift__error shift__error-secondary"
}
const _hoisted_33 = { key: 4 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "shift-miss-layout"
}
const _hoisted_36 = { class: "shift-miss-layout-inner" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "shift-miss-layout-comment" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "shift__content" }

import { computed, nextTick, onBeforeMount, onBeforeUnmount, onMounted, ref } from 'vue'
import {
  addDays,
  addHours,
  addMonths,
  differenceInCalendarMonths,
  format,
  isBefore,
  isLastDayOfMonth,
  parse,
  startOfDay,
  startOfMonth,
  startOfToday,
} from 'date-fns'
import { ru } from 'date-fns/locale'
import {
  ErrorResponseData,
  FrvQuery,
  MainShift,
  NewUser,
  TimeRange,
  TimeShiftQuery,
  UpdatingShift,
  VacationItem,
} from '@/types'
import { useStore } from 'vuex'
import { dinerCalculation, frvCore } from '@/utils/frv'
import { extractDatePartsGURV } from '@/utils/gurv'
import { v4 as uuid } from 'uuid'
import { checkUnsavedChanges, frvTypeList } from '@/utils/main'
import VitaInfoModal from '@/components/UI/VitaInfoModal.vue'
import VitaShiftInfo from '@/components/VitaShiftInfo.vue'
import { PerfectScrollbar, PerfectScrollbarExpose } from 'vue3-perfect-scrollbar'
import VitaButton from '@/components/UI/VitaButton.vue'
import VitaInput from '@/components/UI/VitaInput.vue'
import VitaVacationControl from '@/components/ShiftControl/VitaVacationControl.vue'
import VitaShiftMenuDialog from '@/components/ShiftControl/VitaShiftMenuDialog.vue'
import VitaIcon from '@/components/UI/VitaIcon.vue'
import VitaVacationItem from '@/components/VitaVacationItem.vue'
import { AxiosError } from 'axios'
import { showRequestErrorToast } from '@/utils/toast'
import { reachGoal } from '@/utils/metrika'

interface Props {
  date: string
  position: string
  user: NewUser
  text?: string
  hasVacation?: object | boolean
  showCreate?: boolean
  isUserInactive?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaShiftControl',
  props: {
    date: { default: '' },
    position: { default: 'top right' },
    user: {},
    text: {},
    hasVacation: { type: [Object, Boolean] },
    showCreate: { type: Boolean },
    isUserInactive: { type: Boolean }
  },
  setup(__props: any) {

const store = useStore()

// Есть ли у пользователя роль GURV
const isGurvRole = computed<boolean>(() => {
  return store.getters['getGurvRole']
})

// Есть ли у пользователя роль OFFLINE_DIRECTOR
const isOfflineDirectorRole = computed<boolean>(() => {
  return store.getters['getOfflineDirectorRole']
})

// Есть ли у пользователя роль WFM_READER
const isWFMReaderRole = computed<boolean>(() => {
  return store.getters['getWFMReaderRole']
})

// Есть ли у пользователя роль OFFLINE_ADMIN
const isOfflineAdminRole = computed<boolean>(() => {
  return store.getters['getOfflineAdminRole']
})

const dayOff = computed<boolean>(() => {
  return !store.getters['data/timeSchedule'][props.date].actualWorkTime
})

// Расписание отсутствует, день создан на фронте
const dayScheduleEmpty = computed<boolean>(() => {
  return store.getters['data/timeSchedule'][props.date].emptySchedule
})

const props = __props

const timeSchedule = computed<string>(() => {
  return store.getters['data/timeSchedule'][props.date].actualWorkTime || '00:00-24:00'
})
const pharmId = computed<number>(() => {
  return store.getters['data/pharmId']
})
const timezoneOffset = computed<number>(() => {
  return Math.abs(new Date().getTimezoneOffset() / 60)
})

const scheduleActualWorkTime = computed<string>(() => {
  return store.getters['data/timeSchedule'][props.date].actualWorkTime
})

const shiftBufferObj = computed<null | TimeRange>(() => {
  return store.getters['getShiftBuffer']
})

const nextDate = computed<string>(() => {
  return `${nextDay} ${timeTo.value}`
})
const startTime = timeSchedule.value?.split('-')[0]
const endTime = timeSchedule.value?.split('-')[1]
const currentDay = parse(props.date, 'dd.M.yyyy', new Date())
const nextDay = format(addDays(currentDay, 1), 'dd.M.yyyy')
const formattedNextDay = format(addDays(currentDay, 1), 'd.M.yyyy')
const openModal = ref<boolean>(false)
const openConfirmModal = ref<boolean>(false)
const error = ref<string>('')
const shiftItem = ref<TimeRange>()
const missShiftItem = ref<TimeRange>()
const openedMissSpoiler = ref<boolean>(false)
const newShift = ref<boolean>(
  addDays(new Date(), -3).getTime() < parse(props.date, 'd.M.yyyy', new Date()).getTime(),
)
const updatingOpenId = ref<null | string>('')
const menuOpenId = ref<null | string>('')
let timeFrom = ref<string>(startTime)
const timeFromStatic = ref<string>('00:00')
let timeTo = ref<string>(endTime)
const timeToStatic = ref<string>('00:00')
const dinerTime = ref<string>('')
const timeFRVDiff = ref<FrvQuery>({ frv: 0, frvRV: 0 })
const frvCalcQuery = ref<FrvQuery>({ frv: 0, frvRV: 0 })
const shiftBuffer = ref({})

// Для ПрофиПСТ отдельный тип смены при создании
const shiftType = computed<string>(() => props.user.profiPstUser ? "MainProfi" : "Main");

// ПрофиПСТ попавший в список из смен api/admin-shift (setExternalUsers) - трудоустроен в другой аптеке
const isExternalProfiUser = computed<boolean>(() => props.user.profiPstUser && props.user.externalUser);

const shifts = ref<MainShift>({
  pharmId: pharmId.value,
  zupGuid: props.user.zupGuid,
  userId: props.user.id,
  dateFrom: '',
  dateTo: '',
  shiftStatus: 'New',
  shiftType: shiftType.value,
  tempId: uuid(),
})

const originShiftTimeRange = ref<TimeRange>({
  big: false,
  dateFrom: '',
  dateTo: '',
  diner: null,
  id: '',
  passed: false,
  status: '',
  timeFrom: '',
  timeTo: '',
  type: '',
  zupGuid: '',
  timeZone: 0,
  cancelationReason: '',
  cancelationComment: '',
})

const activeVacationChange = ref(false)
const activeVacationUpdate = ref<string | null>(null)

// Кадровые мероприятия дня лежат вложенным массивом в первом элементе timeShift (см. setAdminShift)
const dayVacations = computed<VacationItem[]>(() => {
  const first = props.user.timeShift?.[props.date]?.[0]
  return Array.isArray(first) ? (first as unknown as VacationItem[]) : []
})

// Логика "Только просмотр" и "Редактирование" в зависимости от состояния переменной updatingOpenId
const currentTimeFrom = computed({
  get: () => (updatingOpenId.value ? timeFromStatic.value : timeFrom.value),
  set: (val: string) => {
    if (!updatingOpenId.value) {
      timeFrom.value = val
    }
  },
})

const currentTimeTo = computed({
  get: () => (updatingOpenId.value ? timeToStatic.value : timeTo.value),
  set: (val: string) => {
    if (!updatingOpenId.value) {
      timeTo.value = val
    }
  },
})

// получаем дату в формате dd.M.yyyy и возвращаем true если это праздник
const isHoliday = computed<boolean>(() => {
  return store.getters['data/holidays'] && store.getters['data/holidays'].includes(props.date)
})

const timeShiftQuery: TimeShiftQuery = {
  timeShift: 0,
  zupGuid: props.user.zupGuid,
  timeShiftNoDiner: 0,
  timeShiftFull: 0,
  holiday: isHoliday.value,
  frvRv: 0,
  dinners: {
    first: {
      startTime: 0,
      endTime: 0,
      duration: 0,
      durationMinutes: 0,
    },
    second: {
      startTime: 0,
      endTime: 0,
      duration: 0,
      durationMinutes: 0,
    },
  },
}

const inProcess = ref<boolean>(false)
const shiftInfoModal = ref({ open: false })

const getPharmacies = async () => {
  await store.dispatch('data/getFondWorkTime')
  await store.dispatch('data/getAdminShift')
  // Обновление расписания для незаполненных дней
  await store.dispatch('data/getTimeScheduleDetails')
  await store.dispatch('data/getTimeSchedule')
  // noinspection ES6MissingAwait
  store.dispatch('data/getFondWorkTimeHuman')
}
const dateTitle = (date: string): string => {
  const formattedDate = format(
    parse(date, 'dd.MM.yyyy', new Date(), { locale: ru }),
    'd MMMM yyyy, EEEE',
    { locale: ru },
  )
  const dayOfWeek = formattedDate.split(',')[1].trim()
  const capitalizedDayOfWeek = dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1)

  return formattedDate.replace(dayOfWeek, capitalizedDayOfWeek)
}
const openDeleteModal = (item: TimeRange) => {
  closeShiftMenu(item)
  openModal.value = true
  shiftItem.value = item
  reachGoal('timetable-shift-delete')
}

const deleteShift = async (e: Event) => {
  e.stopPropagation()
  closeUpdatingItem()

  try {
    inProcess.value = true
    await store.dispatch('data/deleteShift', shiftItem.value)

    await getPharmacies()
    if ((positionCodeIsPicker.value && dayOff.value) || (!dayOff.value && !props.hasVacation)) {
      store.commit('data/saveMainFRV')
      store.commit('data/saveHumanFRV', props.user)
      store.commit('data/changeTimeShift', timeShiftQuery)
      store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
    }
    store.commit('data/closeCreateShift') // Закрываем окно создание смен после удаления смены (OMR-3256)
    checkUnsavedChanges()
    reachGoal('timetable-shift-delete-confirm')
  } catch (e) {
    const err = e as AxiosError<ErrorResponseData>
    if (err.response && localStorage.getItem('token')) showRequestErrorToast(err)
  } finally {
    inProcess.value = false
    openModal.value = false
  }
}

const onShiftDeleteCancel = () => {
  openModal.value = false
  reachGoal('timetable-shift-delete-cancel')
}

const shiftTimesType = (item: TimeRange) => {
  if (!item.zupGuid) {
    return 'not-shift'
  }
  const classArr: string[] = []
  classArr.push(`shift__times-${item.status.toLowerCase()}`)

  if ((!positionCodeIsPicker.value && dayOff.value) || dayScheduleEmpty.value) {
    classArr.push('shift__times-dayoff')
  }

  if (!isGurvRole.value) {
    classArr.push('shift__times-hidden')
  }

  if (item.type === 'Exchange') {
    classArr.push('shift__times-exchange')
  }

  if (!canUpdateShift(item)) {
    classArr.push('shift__times-default')
  }

  return classArr.join(' ')
}

// Принимаем строку со временем в формате 00:00 и отдаём количество секунд
const timeToSeconds = (time: string): number => {
  const hours: number = +time.split(':')[0]
  const minutes: number = +time.split(':')[1]
  return (hours * 60 + minutes) * 60
}

// Принимаем количество секунд и отдаём строку в формате 00:00
const secondsToTime = (second: number): string => {
  const hours = Math.floor(second / 60 / 60)
  const minutes = Math.floor(second / 60) - hours * 60
  const minutesString = minutes.toString().length > 1 ? minutes : '0' + minutes
  return `${hours}:${minutesString}`
}

const isLastDay = isLastDayOfMonth(currentDay)

// Расчёт обедов и длительности смены
const updateDinerTime = () => {
  dinerTime.value = dinerCalculation(
    timeShiftQuery,
    timeFrom,
    timeTo,
    currentDay,
    props.user.timeZone,
  )
}

const removeDinnerTime = () => {
  if (!updatingOpenId.value) dinerTime.value = ''
}

// Попадает ли время в рабочие часы аптеки
const isWithinWorkingHours = (from: string, to: string, start: string, end: string) => {
  return timeToSeconds(from) >= timeToSeconds(start) && timeToSeconds(to) <= timeToSeconds(end)
}

//
const inputEvent = () => {
  // Проверка на NaN при вводе в input
  if (timeFrom.value == '' || timeTo.value == '') {
    timeShiftQuery.timeShift = 0
    timeShiftQuery.frvRv = 0
    error.value = 'Введите время начала и завершения смены'

    store.commit('data/changeTimeShift', timeShiftQuery)
    store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
    return false
  }

  updateDinerTime()

  try {
    if (timeShiftQuery.timeShiftNoDiner > 15) {
      error.value = 'Длительность смены превышает 15 часов'
      removeDinnerTime()
    } else if (
      !positionCodeIsPicker.value &&
      !isWithinWorkingHours(timeFrom.value, timeTo.value, startTime, endTime)
    ) {
      error.value = 'Аптека в это время закрыта'
      removeDinnerTime()
    } else {
      error.value = ''
      shifts.value.dateFrom = addHours(
        parse(`${props.date} ${timeFrom.value}`, 'd.M.yyyy HH:mm', new Date()),
        timezoneOffset.value,
      ).toISOString()
      if (timeToSeconds(timeTo.value) < timeToSeconds(timeFrom.value)) {
        shifts.value.dateTo = addHours(
          parse(nextDate.value, 'd.M.yyyy HH:mm', new Date()),
          timezoneOffset.value,
        ).toISOString()
      } else {
        if (timeTo.value === '24:00') {
          timeTo.value = '00:00'
          shifts.value.dateTo = addHours(
            parse(nextDate.value, 'd.M.yyyy HH:mm', new Date()),
            timezoneOffset.value,
          ).toISOString()
        } else {
          shifts.value.dateTo = addHours(
            parse(`${props.date} ${timeTo.value}`, 'd.M.yyyy HH:mm', new Date()),
            timezoneOffset.value,
          ).toISOString()
        }
      }
    }

    if (updatingOpenId.value) {
      // Активно редактирование смены
      const todayDateTimeISO = new Date().toISOString()
      const realTodayDateTimeISO = addHours(
        new Date(todayDateTimeISO),
        props.user.timeZone,
      ).toISOString()
      const shiftStatus = originShiftTimeRange.value.status

      if (shiftStatus !== 'Active' && realTodayDateTimeISO > shifts.value.dateFrom) {
        error.value =
          'Невозможно внести изменения, так как начало смены не может быть установлено раньше, чем текущее время'
        !updatingOpenId.value ? (dinerTime.value = '') : null
      }

      if (!error.value && shifts.value.dateTo < realTodayDateTimeISO) {
        error.value =
          'Невозможно внести изменения, так как окончание смены не может быть установлено раньше, чем текущее время'
        !updatingOpenId.value ? (dinerTime.value = '') : null
      }
    }

    // Переходящие смены в круглосуточных (и не очень) днях
    if (!positionCodeIsPicker.value && timeShiftQuery.timeShiftNoDiner <= 15) {
      if (!scheduleActualWorkTime.value) return // Не применяем в выходной день

      // Не применяем в последнем дне месяца или перед днём БЕЗ РАСПИСАНИЯ (OMR-2966)
      if (scheduleNextDayWorkTime.value === '00:00-00:00') return

      // Запрещаем создавать переходящие смены в нерабочие часы следующего дня
      if (scheduleNextDayWorkTime.value) {
        if (
          timeToSeconds(timeFrom.value) > timeToSeconds(timeTo.value) &&
          timeToSeconds(timeTo.value) > timeToSeconds(scheduleNextDayWorkTime.value.split('-')[1])
        ) {
          error.value = 'Аптека в это время закрыта'
          removeDinnerTime()
          return false
        }

        // Проверяем последнюю часть времени текущего дня и первую часть следующего дня
        if (
          scheduleActualWorkTime.value.split('-')[1] === '24:00' &&
          scheduleNextDayWorkTime.value.split('-')[0] === '00:00'
        ) {
          error.value = ''
        } else {
          if (
            scheduleActualWorkTime.value !== '00:00-24:00' &&
            timeToSeconds(timeFrom.value) > timeToSeconds(timeTo.value)
          ) {
            error.value = 'Аптека в это время закрыта'
            removeDinnerTime()
          }

          if (scheduleNextDayWorkTime.value !== '00:00-24:00') {
            if (
              timeToSeconds(timeFrom.value) > timeToSeconds(timeTo.value) &&
              timeTo.value !== '00:00'
            ) {
              error.value = 'Аптека в это время закрыта'
              removeDinnerTime()
            }
          }
        }
      }
    }

    if (updatingOpenId.value) {
      updatedShift.value.dateFrom = shifts.value.dateFrom
      updatedShift.value.dateTo = shifts.value.dateTo
    }
  } catch (e) {
    console.error(e)
    error.value = 'Введите время начала и завершения смены'
  }

  frvCalcQuery.value = frvCore(timeShiftQuery, isLastDay, isHoliday, shifts, timeFrom, timeTo)
  timeShiftQuery.timeShift = frvCalcQuery.value.frv
  timeShiftQuery.frvRv = frvCalcQuery.value.frvRV

  if ((positionCodeIsPicker.value && dayOff.value) || (!dayOff.value && !props.hasVacation)) {
    store.commit('data/changeTimeShift', timeShiftQuery)
    store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
  }
}

const setValidInputTime = () => {
  if (timeToSeconds(timeTo.value) - timeToSeconds(timeFrom.value) > timeToSeconds('15:00')) {
    timeTo.value = secondsToTime(timeToSeconds(timeFrom.value) + timeToSeconds('15:00'))
  }

  if (props.user.grade === 10 && timeToSeconds(startTime) < timeToSeconds('06:00')) {
    timeFrom.value = '06:00'
  }
}

const addShift = async () => {
  inProcess.value = true

  shifts.value.shiftType = shiftType.value
  const { statusCode } = await store.dispatch('data/addShift', shifts.value)
  if (statusCode >= 400) {
    inProcess.value = false
    return
  }

  // noinspection ES6MissingAwait
  store.dispatch('data/getFondWorkTime')
  // noinspection ES6MissingAwait
  store.dispatch('data/getFondWorkTimeHuman')
  await store.dispatch('data/getPharmSchedule')
  await store.dispatch('data/getAdminShift')
  // Обновление расписания для незаполненных дней
  await store.dispatch('data/getTimeScheduleDetails')
  await store.dispatch('data/getTimeSchedule')
  // Обновляем ФРВ после создания смены (OMR-3583)
  store.commit('data/changeTimeShift', timeShiftQuery)
  store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)

  inProcess.value = false
  checkUnsavedChanges()
  // Проверяем высоту списка смен при создании (OMR-3896)
  await checkShiftsHeight()
  reachGoal('timetable-create-shift')
}

const closeShifts = (e: MouseEvent) => {
  e.stopPropagation()
  if (updatingOpenId.value) {
    store.commit('data/resetMainFRV')
    store.commit('data/resetHumanFRV', { user: props.user })
  }

  if (activeVacationChange.value) {
    openConfirmModal.value = true
    return false
  }
  store.commit('data/closeCreateShift')
}

const updateFRVquery = () => {
  store.commit('data/changeTimeShift', timeShiftQuery)
  store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
}

const scheduleNextDayWorkTime = computed<string>(() => {
  if (store.getters['data/timeSchedule'][formattedNextDay]) {
    return store.getters['data/timeSchedule'][formattedNextDay].actualWorkTime
  }
  return false
})

const updatedShift = ref<UpdatingShift>({
  id: null,
  dateFrom: '',
  dateTo: '',
  tempId: uuid(),
})

// Восстановление состояния инпутов для обновления смены
const restoreInputsState = () => {
  timeFrom = ref<string>(startTime)
  timeTo = ref<string>(endTime)
  error.value = ''
  setValidInputTime()
  updateDinerTime()

  // Убрано обновление ФРВ из-за неверного пересчета (OMR-3039)
}

// Проверка на возможность пересчёта планового ФРВ аптеки по смене
const canChangePharmFRV = (item: TimeRange) => {
  // У уборщиков, дворников и заведующих основной ФРВ не меняется
  const isEditableGrade = props.user.grade !== 10

  // Сотрудники и смены ПрофиПСТ в ФРВ аптеки не входят
  const isNotProfi = !props.user.profiPstUser && item.type !== 'MainProfi'

  // Типы ФРВ, у которых разрешено изменение (включая сотрудников из других аптек)
  const isEditableFrvType = Boolean(
    props.user.frv?.frvType && frvTypeList.includes(props.user.frv.frvType),
  )

  return isEditableGrade && isNotProfi && isEditableFrvType
}

// Открыто обновление смены
const openUpdatingItem = (item: TimeRange) => {
  if (updatingOpenId.value) {
    closeUpdatingItem()
  }
  error.value = ''
  store.commit('data/saveMainFRV')
  store.commit('data/saveHumanFRV', props.user) // Сохраняем humanFRV для перерасчёта при закрытии (OMR-3583)
  originShiftTimeRange.value = item

  // Устанавливаем время редактируемой смены
  timeFrom = ref<string>(item.timeFrom)
  timeTo = ref<string>(item.timeTo)

  timeShiftQuery.timeShift = 0
  timeShiftQuery.frvRv = 0

  store.commit('data/changeTimeShift', timeShiftQuery)
  store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)

  updateDinerTime()

  timeFRVDiff.value = frvCore(timeShiftQuery, isLastDay, isHoliday, shifts, timeFrom, timeTo)

  timeShiftQuery.timeShift = timeFRVDiff.value.frv
  timeShiftQuery.frvRv = timeFRVDiff.value.frvRV

  store.commit('data/changeTimeShift', timeShiftQuery)
  store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)

  if (canChangePharmFRV(item)) {
    store.commit('data/changeMainFRV', {
      frv: timeFRVDiff.value.frv,
      frvRV: timeFRVDiff.value.frvRV,
    })
  }

  store.commit('data/changeHumanFRV', {
    frv: timeFRVDiff.value.frv,
    frvRV: timeFRVDiff.value.frvRV,
    user: props.user,
  })

  // Добавляем ID смены и текущее время (переводя в ISO формат) в объект для обновления
  updatedShift.value.id = item.id
  updatedShift.value.dateFrom = addHours(
    parse(
      `${originShiftTimeRange.value.dateFrom} ${originShiftTimeRange.value.timeFrom}`,
      'd.M.yyyy HH:mm',
      new Date(),
    ),
    timezoneOffset.value,
  ).toISOString()
  updatedShift.value.dateTo = addHours(
    parse(
      `${originShiftTimeRange.value.dateTo} ${originShiftTimeRange.value.timeTo}`,
      'd.M.yyyy HH:mm',
      new Date(),
    ),
    timezoneOffset.value,
  ).toISOString()

  // Устанавливаем статус - активно редактирование для элемента
  updatingOpenId.value = item.id
}

const closeUpdatingItem = () => {
  store.commit('data/resetMainFRV')
  store.commit('data/resetHumanFRV', { user: props.user })
  timeFrom = ref<string>(startTime)
  timeTo = ref<string>(endTime)
  error.value = ''
  updatingOpenId.value = null
  setValidInputTime()
  if (newShift.value) {
    inputEvent()
  }
  if ((positionCodeIsPicker.value && dayOff.value) || (!dayOff.value && !props.hasVacation)) {
    store.commit('data/changeTimeShift', timeShiftQuery)
    store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
  }
}

const updateShift = async () => {
  inProcess.value = true

  try {
    await store.dispatch('data/updateShift', updatedShift.value)
    await getPharmacies()
    if ((positionCodeIsPicker.value && dayOff.value) || (!dayOff.value && !props.hasVacation)) {
      updateFRVquery()
    }
    updatingOpenId.value = null
    restoreInputsState()
    store.commit('data/saveHumanFRV', props.user)
    store.commit('data/closeCreateShift')
  } catch (e) {
    const err = e as AxiosError<ErrorResponseData>
    if (err.response && localStorage.getItem('token')) showRequestErrorToast(err)
  } finally {
    inProcess.value = false
  }
}

const isCrossingShift = (item: TimeRange) => {
  const isTomorrowDay = timeTo.value <= timeFrom.value
  const tomorrowDate = addDays(
    addHours(parse(props.date, 'd.M.yyyy', new Date()), timezoneOffset.value),
    1,
  )
  if (item.big && updatingOpenId.value !== item.id) {
    item.dateTo = format(tomorrowDate, 'd.M.yyyy')
    return true
  }
  if (timeTo.value === timeFrom.value) {
    return false
  }
  if ((item.big || (item.timeTo <= item.timeFrom && isLastDay)) && !updatingOpenId.value) {
    return true
  } else if (isTomorrowDay && updatingOpenId.value && updatingOpenId.value === item.id) {
    item.dateTo = format(tomorrowDate, 'd.M.yyyy')
    return true
  } else {
    return false
  }
}

const openMissSpoiler = (item: TimeRange) => {
  openedMissSpoiler.value = !openedMissSpoiler.value
  missShiftItem.value = item
  checkShiftsHeight()
}

const canUpdateShift = (item: TimeRange) => {
  const { creatingDay, creatingMonth, currentMonthNumber, previousMonthNumber, currentDay } =
    extractDatePartsGURV(props.date)

  const isNotExchange = item.type !== 'Exchange';
  const isNotProfiPst = item.type !== 'ProfiPst';
  const isNotMiss = item.status !== 'Miss';
  const isNotMissAccepted = item.status !== 'MissAccepted';
  const isNotCanceled = item.status !== 'Canceled';
  const isDone = item.status === 'Done';
  const isPositionOrActiveOrNew = positionCodeIsPicker.value || item.status === 'Active' || (item.status === 'New' && !dayOff.value);
  const isDayScheduleNotEmpty = !dayScheduleEmpty.value;

  if (isOfflineDirectorRole.value || isWFMReaderRole.value) {
    return false
  }

  if (isDone && positionCodeIsPicker.value) {
    return false
  }

  // Смена в прошлом месяце
  if (creatingMonth === previousMonthNumber) {
    return false
  }

  // 2 числа по дате текущего месяца запрещаем менять смены на последние числа прошлого месяца (для всех ролей)
  if (currentDay === 2 && creatingDay <= 31 && creatingMonth !== currentMonthNumber) {
    return false
  }

  return (
    !dayOff.value &&
    isNotMiss &&
    isNotCanceled &&
    isNotMissAccepted &&
    isNotExchange &&
    isNotProfiPst &&
    isPositionOrActiveOrNew &&
    isDayScheduleNotEmpty
  )
}

const onUpdateShiftClick = (item: TimeRange) => {
  const isNotUpdatingSameItem = updatingOpenId.value !== item.id

  // Закрываем меню действий у смены
  closeShiftMenu(item)

  if (canUpdateShift(item) && isNotUpdatingSameItem) {
    reachGoal('timetable-shift-edit')
    return openUpdatingItem(item)
  } else {
    return null
  }
}

// Проверка на возможность обновить смену в выбранный день
const isUpdateShiftAvailable = (item: TimeRange) => {
  return canUpdateShift(item)
}

// Является ли пользователь комплектовщиком
const positionCodeIsPicker = computed<boolean>(() => {
  return props.user.positionCode === 'Комплектовщик'
})

// Проверка, что ГУРВ может создавать смены в определённом диапазоне в прошлом
const canGurvEditPastShift = () => {
  const { creatingDay, creatingMonth, currentMonthNumber, previousMonthNumber, currentDay } =
    extractDatePartsGURV(props.date)

  if (isGurvRole.value) {
    if (!dayScheduleEmpty.value || positionCodeIsPicker.value) {
      // Создавать смены в прошлом месяце
      if (creatingMonth === previousMonthNumber) {
        return true
      }
      // ГУРВ может создавать смены с начала текущего месяца
      if (creatingMonth === currentMonthNumber && creatingDay <= currentDay) {
        return true
      }
    }
  }
}

// Проверка на возможность создать смену в выбранный день
const canCreateShift = () => {
  const { creatingDay, creatingMonth, currentMonthNumber, currentDay, previousMonthNumber } =
    extractDatePartsGURV(props.date)

  // ПрофиПСТ из другой аптеки: смены ему создаются только по месту трудоустройства
  if (isExternalProfiUser.value) {
    return false
  }

  // ПрофиПСТ из другой аптеки: смены ему создаются только по месту трудоустройства
  if (isExternalProfiUser.value) {
    return false
  }

  if (isOfflineDirectorRole.value || isWFMReaderRole.value) {
    return false
  }

  // Проверка у ГУРВ на пустой день для всех кроме Комплектовщиков
  if (isGurvRole.value) {
    // В выходной день запрещаем создание смен для всех кроме Комплектовщиков
    if (dayOff.value && !positionCodeIsPicker.value) {
      return false
    }

    if (
      (canGurvEditPastShift() && !dayScheduleEmpty.value) ||
      (canGurvEditPastShift() && positionCodeIsPicker.value && dayScheduleEmpty.value)
    ) {
      return true
    }
  }

  // С 17 числа по дате текущего месяца запрещаем менять смены 15 числа
  if (currentDay >= 17 && creatingDay === 15 && creatingMonth === currentMonthNumber) {
    return false
  }

  // 2 числа по дате текущего месяца запрещаем менять смены на последние числа прошлого месяца (для всех кроме ГУРВ)
  if (currentDay === 2 && creatingDay <= 31 && creatingMonth === previousMonthNumber) {
    newShift.value = false // Убираем пересчёт ФРВ
    return false
  }

  // Основная проверка
  if (
    (newShift.value && !dayOff.value && !dayScheduleEmpty.value) ||
    (positionCodeIsPicker.value && newShift.value)
  ) {
    return true
  }
}

// Проверка на возможность удалить смену в выбранный день
const isDeleteShiftAvailable = (item: TimeRange) => {
  const { creatingMonth, currentDay, creatingDay, previousMonthNumber } = extractDatePartsGURV(
    props.date,
  )

  // Запрещаем удалять смены БЕРУ и со статусом Miss
  if (item.type === 'Exchange' || item.status === 'Miss') {
    return false
  }

  // Запрещаем удалять смены с определёнными статусами (OMR-3385)
  if (item.status === 'Canceled' || item.status === 'MissAccepted') {
    return false
  }

  // Запрещаем удалять смены для группы OFFLINE_DIRECTOR
  if (isOfflineDirectorRole.value) {
    return false
  }

  // Условия для группы GURV
  if (isGurvRole.value) {
    const previousMonthDate = startOfMonth(addMonths(new Date(), -1)) // прошлый месяц
    const shiftStartDate = parse(item.dateFrom, 'd.M.yyyy', new Date()) // дата начала смены
    // Переходящие смены созданные в позапрошлом месяце
    if (differenceInCalendarMonths(shiftStartDate, previousMonthDate) < 0) {
      return false
    }

    // Остальные проверки для GURV
    if (
      canGurvEditPastShift() ||
      item.status === 'New' ||
      item.status === 'Active' ||
      item.status === 'Done'
    ) {
      return true
    }
  }

  // 2 числа по дате текущего месяца запрещаем менять смены на последние числа прошлого месяца (для всех кроме ГУРВ)
  if (currentDay === 2 && creatingDay <= 31 && creatingMonth === previousMonthNumber) {
    return false
  }

  // Для всех остальных смен со статусом New доступно удаление
  return item.status === 'New'
}

// Проверка на возможность копировать смену в выбранный день
const isCopyShiftAvailable = (item: TimeRange) => {
  return item.id
}

const onCopyShiftClick = (item: TimeRange) => {
  closeShiftMenu(item)
  shiftBuffer.value = {
    dateFrom: item.dateFrom,
    dateTo: item.dateTo,
    shiftStatus: 'New',
    shiftType: shiftType.value,
    tempId: uuid(),
    pharmId: pharmId.value,
    zupGuid: props.user.zupGuid,
    userId: props.user.id,
    timeFrom: item.timeFrom,
    timeTo: item.timeTo,
  }
  store.commit('copyShift', shiftBuffer.value)
  reachGoal('timetable-copy-shift')
}

const canOpenShiftMenu = (item: TimeRange) => {
  // Отключаем меню для группы OFFLINE_DIRECTOR, при активном редактировании смены, для смен с типом Беру
  if (isOfflineDirectorRole.value || updatingOpenId.value) return false;
  if (item.type === 'ProfiPst') return false;
  return item.type !== 'Exchange';
}

// Открытие меню действий у смены
const openShiftMenu = (item: TimeRange) => {
  if (menuOpenId.value === item.id) {
    closeShiftMenu(item)
  } else {
    menuOpenId.value = item.id
    reachGoal('timetable-shift-menu-open')
  }
}

// Закрытие меню действий у смены
const closeShiftMenu = (item: TimeRange) => {
  if (menuOpenId.value && menuOpenId.value === item.id) {
    menuOpenId.value = null
  }
}

const pasteShift = (date: string) => {
  // Проверяем на наличие скопированной смены
  if (!shiftBufferObj.value || Object.keys(shiftBufferObj.value).length === 0) {
    return false
  }

  // Если смена переходящая
  if (timeToSeconds(shiftBufferObj.value.timeTo) < timeToSeconds(shiftBufferObj.value.timeFrom)) {
    shifts.value.dateTo = addHours(
      parse(`${nextDay} ${shiftBufferObj.value.timeTo}`, 'd.M.yyyy HH:mm', new Date()),
      timezoneOffset.value,
    ).toISOString()
  } else {
    shifts.value.dateTo = addHours(
      parse(`${date} ${shiftBufferObj.value.timeTo}`, 'd.M.yyyy HH:mm', new Date()),
      timezoneOffset.value,
    ).toISOString()
  }

  shifts.value.dateFrom = addHours(
    parse(`${date} ${shiftBufferObj.value.timeFrom}`, 'd.M.yyyy HH:mm', new Date()),
    timezoneOffset.value,
  ).toISOString()

  addShift()
  reachGoal('timetable-paste-shift')
}

// Получение заголовка со временем скопированной смены
const pasteShiftTitle = computed(() => {
  if (shiftBufferObj.value?.timeFrom) {
    return `Скопировано ${shiftBufferObj.value.timeFrom} - ${shiftBufferObj.value.timeTo}`
  }
  return 'Смена не скопирована'
})

// Проверка на возможность просмотра информации о смене в выбранный день (только для ГУРВ и основных смен)
const isInfoShiftAvailable = (item: TimeRange) => {
  if (isGurvRole.value && item.type !== 'Partner' && item.type !== 'MainProfi') {
    return item.id
  }
}

const openShiftInfoModal = () => {
  shiftInfoModal.value.open = true
}

const closeShiftInfoModal = () => {
  shiftInfoModal.value.open = false
}

// Передаём ID смены в компонент показа информации
const shiftInfoId = ref('')

const onInfoShiftClick = (item: TimeRange) => {
  if (item.id) {
    shiftInfoId.value = item.id
    closeShiftMenu(item)
    openShiftInfoModal()
    reachGoal('timetable-shift-info')
  }
}

onBeforeMount(async () => {
  // Отменяем все действия при открытии для группы OFFLINE_DIRECTOR и WFM_READER, а также для нетрудоустроенных
  if (isOfflineDirectorRole.value || isWFMReaderRole.value || props.isUserInactive) {
    return false
  }

  if (canCreateShift() || newShift.value) {
    setValidInputTime()
    // noinspection ES6RedundantAwait
    await inputEvent()
  }

  if ((positionCodeIsPicker.value && dayOff.value) || (!dayOff.value && !props.hasVacation)) {
    // Если нет расписания на день (применяем ко всем, кроме комплектовщиков)
    if (dayScheduleEmpty.value && !positionCodeIsPicker.value) {
      timeShiftQuery.timeShift = 0
      timeShiftQuery.frvRv = 0
    }
    store.commit('data/saveMainFRV')
    store.commit('data/saveHumanFRV', props.user)
    store.commit('data/changeTimeShift', timeShiftQuery)
    store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
  }
})
onBeforeUnmount(() => {
  // Отменяем все действия при открытии для группы OFFLINE_DIRECTOR и WFM_READER
  if (isOfflineDirectorRole.value || isWFMReaderRole.value) {
    return false
  }

  if (
    ((canCreateShift() || newShift.value) && positionCodeIsPicker.value && dayOff.value) ||
    (!dayOff.value && !props.hasVacation)
  ) {
    timeShiftQuery.timeShift = 0
    timeShiftQuery.frvRv = 0
    store.commit('data/changeTimeShift', timeShiftQuery)
    store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
  }

  // Закрываем и отменяем обновление смены (OMR-4127)
  if (updatingOpenId.value) {
    timeShiftQuery.timeShift = 0
    timeShiftQuery.frvRv = 0
    store.commit('data/resetMainFRV')
    store.commit('data/resetHumanFRV', { user: props.user })
    store.commit('data/changeTimeShift', timeShiftQuery)
    store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
  }
})

// Проверяем, что дата в прошлом для вывода ошибки "Невозможно создать смену на прошедший день"
const dayIsPassed = computed<boolean>(() => {
  return addDays(new Date(), -3).getTime() > parse(props.date, 'd.M.yyyy', new Date()).getTime()
})

// Проверки для зарплатных дней (2 и 17 число) (OMR-3438)
const salaryDaysRestriction = computed(() => {
  const { creatingDay, creatingMonth, currentMonthNumber, previousMonthNumber, currentDay } =
    extractDatePartsGURV(props.date)
  // Не выводим ошибку у ГУРВ (OMR-3778)
  if (isGurvRole.value) return false

  // С 17 числа по дате текущего месяца запрещаем менять смены 15 числа (OMR-3438)
  if (currentDay >= 17 && creatingDay === 15 && creatingMonth === currentMonthNumber) {
    return true
  }

  // 2 числа по дате текущего месяца запрещаем менять смены на последние числа прошлого месяца (для всех кроме ГУРВ)
  if (currentDay === 2 && creatingDay <= 31 && creatingMonth === previousMonthNumber) {
    return true
  }

  return false
})

// Варианты ошибок при создании смены
// Невозможно создать смену на прошедший день
const pastDayError = computed(() => {
  if (salaryDaysRestriction.value) return true // Выводим ошибку в дни зарплат (OMR-3438)

  if (!dayIsPassed.value) return false

  // Не показываем ошибку при кадровом
  if (hasVacationOnDay(props.user, props.date)) {
    return false
  }

  if (isGurvRole.value && dayIsPassed.value && dayOff.value) {
    return false
  }

  if (isOfflineAdminRole.value && dayIsPassed.value) {
    return true
  }

  if (!dayScheduleEmpty.value || positionCodeIsPicker.value) {
    return true
  }

  return false
})

// Отсутствует расписание аптеки
const scheduleError = computed(() => {
  if (dayOff.value) return false

  // Не показываем ошибку при кадровом
  if (hasVacationOnDay(props.user, props.date)) {
    return false
  }

  if (!dayIsPassed.value && dayScheduleEmpty.value) {
    return true
  }

  if (!isOfflineAdminRole.value || !positionCodeIsPicker.value) {
    return true
  }

  return false
})

// Невозможно создать смену. В аптеке выходной день
const dayOffError = computed(() => {
  if (!dayOff.value) return false

  // Не показываем ошибку при кадровом
  if (hasVacationOnDay(props.user, props.date)) {
    return false
  }

  if (isGurvRole.value && dayIsPassed.value) {
    return true
  }

  if ((isOfflineAdminRole.value || isGurvRole.value) && !dayIsPassed.value) {
    return true
  }

  return false
})

const shiftsScrollList = ref<PerfectScrollbarExpose | null>(null)
const isScrollable = ref(false)

// Проверка на высоту блока со сменами заданную в CSS (OMR-3385)
const checkShiftsHeight = async () => {
  await nextTick()

  const el = shiftsScrollList.value?.ps?.element
  if (!el) return

  // Получаем высоту блока из CSS и при превышении включаем скролл (OMR-4523)
  const contentHeight = el.offsetHeight
  const computedStyle = window.getComputedStyle(el)
  const contentMaxHeight = parseInt(computedStyle.maxHeight, 10)

  if (contentHeight && !isNaN(contentMaxHeight)) {
    isScrollable.value = contentHeight >= contentMaxHeight
  }
}

onMounted(() => {
  checkShiftsHeight()
})

// В массиве только смены (OMR-3385)
const hasOnlyShifts = (arr: TimeRange[]) => {
  if (!arr) return false
  return arr.every((obj) => 'zupGuid' in obj)
}

// В массиве только отменённые смены (OMR-3385)
const hasOnlyMissedShifts = (arr: TimeRange[]) => {
  if (!arr || arr.length === 0) return false

  return arr.every((obj) => obj.status === 'MissAccepted' || obj.status === 'Canceled')
}

// Есть кадровые в текущем дне (OMR-3385)
const hasVacationOnDay = (user: NewUser, date: string) => {
  if (!user.timeShift || !user.timeShift[date]) return

  if (user.timeShift[date].length > 0 && !user.timeShift[date].every((obj) => 'zupGuid' in obj)) {
    return true
  }
}

// Показываем ли блок со сменами (OMR-3385)
const isShiftsVisible = (user: NewUser, date: string) => {
  // Добавлена проверка на наличие элементов с zupGuid (OMR-3926)
  if (
    !user.timeShift ||
    !user.timeShift[date] ||
    !user.timeShift[date].some((obj) => 'zupGuid' in obj)
  )
    return false

  // У ГУРВ отображаем отмененные смены
  if (isGurvRole.value && user.timeShift[date].length > 0) return true

  // У OFFLINE_USER и OFFLINE_DIRECTOR не отображаем отмененные смены
  if (
    (isOfflineDirectorRole.value || isOfflineAdminRole.value) &&
    hasOnlyMissedShifts(user.timeShift[date])
  )
    return false

  // В остальных случаях отображаем если смены есть
  return hasOnlyShifts(user.timeShift[date]) && user.timeShift[date].length > 0
}

const canCreateVacation = (user, date: string) => {
  if (!user || (!user.timeShift && !user.timeShift[date]) || !date) return false

  if (props.isUserInactive) return false

  // Не разрешаем проставить НН на днях с isAbsence
  const shiftItems = user.timeShift[date]
  if (Array.isArray(shiftItems) && shiftItems.some((item) => item.type === 'isAbsence')) {
    return false
  }

  const selectedDate = parse(date, 'd.M.yyyy', new Date())
  const normalizedDate = startOfDay(selectedDate)

  // Разрешаем для OFFLINE_DIRECTOR с ролью OFFLINE_ADMIN, а так же всем с OFFLINE_ADMIN и GURV (OMR-5603)
  const permittedRole =
    (isOfflineAdminRole.value && isOfflineDirectorRole.value) ||
    isGurvRole.value ||
    isOfflineAdminRole.value

  // Возможно проставить НН если пользователь не внешний, имеет необходимые права и дата сегодня или позднее
  return permittedRole && !user.externalUser && !isBefore(normalizedDate, startOfToday())
}

const openVacationEdit = () => {
  activeVacationChange.value = true
}

const closeVacationEdit = () => {
  activeVacationChange.value = false
  activeVacationUpdate.value = null
  openConfirmModal.value = false
}

// Текст отображаемый при наличии dateDismissal или dateOfEmployment
const inactiveReasonText = computed<string>(() => {
  const cellDate = startOfDay(parse(props.date, 'dd.MM.yyyy', new Date()))
  const { dateOfEmployment, dateDismissal } = props.user

  // Вывод строки с датой трудоустройства
  if (dateOfEmployment && isBefore(cellDate, new Date(dateOfEmployment))) {
    return `Трудоустройство с ${format(new Date(dateOfEmployment), 'dd.MM', { locale: ru })}`
  }

  // Вывод строки с датой увольнения
  if (dateDismissal) {
    const dismissalDate = new Date(dateDismissal)

    // Если указана дата увольнения, то выводим эту дату + 1 день
    if (!isBefore(cellDate, dismissalDate)) {
      return `Увольнение с ${format(addDays(dismissalDate, 1), 'dd.MM', { locale: ru })}`
    }
  }

  return ''
})

// Проверка на isAbsence в выбранном дне
const hasAbsenceOnDay = (user: NewUser, date: string) => {
  if (!user.timeShift || !user.timeShift[date]) return false

  const dayEntries = user.timeShift[date]

  if (!Array.isArray(dayEntries)) return false

  return dayEntries.flat().some((item) => item?.type === 'isAbsence')
}

return (_ctx: any,_cache: any) => {
  const _component_vita_modal = _resolveComponent("vita-modal")!
  const _directive_click_outside_element = _resolveDirective("click-outside-element")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      (__props.user.timeShift && __props.user.timeShift[__props.date]) ||
      positionCodeIsPicker.value ||
      !dayOff.value ||
      dayOff.value ||
      __props.hasVacation
    )
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["shift", [__props.position]])
        }, [
          _createElementVNode("h2", _hoisted_1, [
            _createTextVNode(_toDisplayString(dateTitle(__props.date)) + " ", 1),
            _createVNode(VitaIcon, {
              name: "cross",
              class: "icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (closeShifts($event))),
              "data-qa": "shift-control-icon-close"
            })
          ]),
          _createElementVNode("div", null, [
            (!__props.hasVacation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (__props.isUserInactive)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(inactiveReasonText.value), 1))
                    : _createCommentVNode("", true),
                  (!activeVacationChange.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (canCreateShift() || hasVacationOnDay(__props.user, __props.date))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              (!__props.isUserInactive && canCreateShift() && !hasVacationOnDay(__props.user, __props.date))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "shift__form-head" }, [
                                      _createElementVNode("p", { class: "shift__title" }, "Создать смену")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_5, [
                                      _createVNode(VitaInput, {
                                        delete: false,
                                        modelValue: currentTimeFrom.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentTimeFrom).value = $event)),
                                        type: "time",
                                        icon: "enter",
                                        onInput: inputEvent,
                                        disabled: !!updatingOpenId.value,
                                        "data-qa": "shift-control-input-time-from"
                                      }, null, 8, ["modelValue", "disabled"]),
                                      _createVNode(VitaInput, {
                                        delete: false,
                                        modelValue: currentTimeTo.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentTimeTo).value = $event)),
                                        type: "time",
                                        icon: "exit",
                                        onInput: inputEvent,
                                        disabled: !!updatingOpenId.value,
                                        "data-qa": "shift-control-input-time-to"
                                      }, null, 8, ["modelValue", "disabled"]),
                                      _createVNode(VitaButton, {
                                        disabled: !!updatingOpenId.value || inProcess.value || !!error.value,
                                        width: "inline",
                                        onClick: addShift,
                                        "data-qa": "shift-control-button-add-shift"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(VitaIcon, { name: "checked" })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createVNode(VitaButton, {
                                        class: _normalizeClass({ 'not-available': !shiftBufferObj.value }),
                                        width: "inline",
                                        color: "orange",
                                        onClick: _cache[3] || (_cache[3] = ($event: any) => (pasteShift(__props.date))),
                                        disabled: !!updatingOpenId.value || inProcess.value,
                                        title: pasteShiftTitle.value,
                                        "data-qa": "shift-control-button-paste-shift"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(VitaIcon, { name: "duplicate" })
                                        ]),
                                        _: 1
                                      }, 8, ["class", "disabled", "title"])
                                    ]),
                                    (dinerTime.value && !updatingOpenId.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                          _createVNode(VitaIcon, {
                                            name: "cup",
                                            class: "icon"
                                          }),
                                          _cache[15] || (_cache[15] = _createElementVNode("div", null, "Перерыв:", -1)),
                                          _createElementVNode("div", null, _toDisplayString(dinerTime.value), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (error.value && !updatingOpenId.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(error.value), 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (!__props.isUserInactive && hasVacationOnDay(__props.user, __props.date))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dayVacations.value, (item, idx) => {
                                        return (_openBlock(), _createBlock(VitaVacationItem, {
                                          key: idx,
                                          vacation: item,
                                          zupGuid: __props.user.zupGuid,
                                          userCanEdit: canCreateVacation(__props.user, __props.date),
                                          visible: activeVacationChange.value,
                                          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((activeVacationChange).value = $event)),
                                          visibleUpdate: activeVacationUpdate.value,
                                          "onUpdate:visibleUpdate": _cache[5] || (_cache[5] = ($event: any) => ((activeVacationUpdate).value = $event))
                                        }, null, 8, ["vacation", "zupGuid", "userCanEdit", "visible", "visibleUpdate"]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (!canCreateShift())
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (isExternalProfiUser.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[17] || (_cache[17] = [
                                    _createElementVNode("p", { class: "shift__error shift__error-secondary" }, " Создание смен для данного сотрудника доступно только в аптеке, где он трудоустроен ", -1)
                                  ]))]))
                                : (!isOfflineDirectorRole.value && !isWFMReaderRole.value && !props.isUserInactive)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      (pastDayError.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[18] || (_cache[18] = [
                                            _createElementVNode("p", { class: "shift__error" }, "Невозможно создать смену на прошедший день.", -1)
                                          ]))]))
                                        : (scheduleError.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[19] || (_cache[19] = [
                                              _createElementVNode("p", { class: "shift__error" }, "Отсутствует расписание аптеки", -1)
                                            ]))]))
                                          : (dayOffError.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[20] || (_cache[20] = [
                                                _createElementVNode("p", { class: "shift__error" }, "Невозможно создать смену. В аптеке выходной день.", -1)
                                              ]))]))
                                            : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (!hasAbsenceOnDay(__props.user, __props.date) && canCreateVacation(__props.user, __props.date))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createElementVNode("button", {
                                class: "shift__link",
                                type: "button",
                                onClick: openVacationEdit,
                                disabled: inProcess.value,
                                "data-qa": "shift-control-button-vacation-add"
                              }, [
                                _cache[21] || (_cache[21] = _createElementVNode("span", null, "Проставить НН", -1)),
                                _createVNode(VitaIcon, { name: "chevron-right" })
                              ], 8, _hoisted_15)
                            ]))
                          : _createCommentVNode("", true),
                        (__props.user.timeShift && isShiftsVisible(__props.user, __props.date))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _cache[27] || (_cache[27] = _createElementVNode("p", { class: "shift__title" }, "Назначенные смены", -1)),
                              _createVNode(_unref(PerfectScrollbar), {
                                ref_key: "shiftsScrollList",
                                ref: shiftsScrollList,
                                class: "scroll-comment rail-thin shift__times-wrap",
                                id: !isScrollable.value && !inProcess.value ? 'no-scroll' : null,
                                options: { wheelPropagation: false, suppressScrollX: true }
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.user.timeShift[__props.date], (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["shift__times-item", shiftTimesType(item)]),
                                      key: item.dateFrom,
                                      "data-editable": isUpdateShiftAvailable(item)
                                    }, [
                                      (isCrossingShift(item))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            _createElementVNode("span", null, "(" + _toDisplayString(item.dateFrom), 1),
                                            _createVNode(VitaIcon, { name: "arrow" }),
                                            _createElementVNode("span", null, _toDisplayString(item.dateTo) + ")", 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("div", null, [
                                          _createVNode(VitaIcon, {
                                            class: "icon",
                                            name: "watch"
                                          })
                                        ]),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["shift__times-time-inner", { 'update-active-span': updatingOpenId.value && updatingOpenId.value === item.id }])
                                        }, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["time-wrapper", { 'update-active': updatingOpenId.value && updatingOpenId.value === item.id }]),
                                            onClick: ($event: any) => (onUpdateShiftClick(item)),
                                            "data-qa": "shift-control-time-open-edit"
                                          }, [
                                            _createElementVNode("div", _hoisted_21, [
                                              (updatingOpenId.value && updatingOpenId.value === item.id)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                    _createVNode(VitaInput, {
                                                      secondaryStyle: "true",
                                                      delete: false,
                                                      modelValue: _unref(timeFrom),
                                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(timeFrom) ? (timeFrom).value = $event : timeFrom = $event)),
                                                      value: _unref(timeFrom),
                                                      type: "time",
                                                      onInput: _cache[7] || (_cache[7] = ($event: any) => (inputEvent())),
                                                      readonly: item.status === 'Active',
                                                      disabled: item.status === 'Active',
                                                      "data-qa": "shift-control-input-edit-time-from"
                                                    }, null, 8, ["modelValue", "value", "readonly", "disabled"]),
                                                    _createVNode(VitaIcon, {
                                                      class: "icon-arrow",
                                                      name: "arrow"
                                                    }),
                                                    _createVNode(VitaInput, {
                                                      secondaryStyle: "true",
                                                      delete: false,
                                                      modelValue: _unref(timeTo),
                                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(timeTo) ? (timeTo).value = $event : timeTo = $event)),
                                                      value: _unref(timeTo),
                                                      type: "time",
                                                      onInput: _cache[9] || (_cache[9] = ($event: any) => (inputEvent())),
                                                      "data-qa": "shift-control-input-edit-time-to"
                                                    }, null, 8, ["modelValue", "value"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                    _createElementVNode("span", null, _toDisplayString(item.timeFrom), 1),
                                                    _createVNode(VitaIcon, {
                                                      class: "icon-arrow",
                                                      name: "arrow"
                                                    }),
                                                    _createElementVNode("span", null, _toDisplayString(item.timeTo), 1)
                                                  ]))
                                            ]),
                                            (updatingOpenId.value && updatingOpenId.value === item.id)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                  _createElementVNode("button", {
                                                    class: "button btn-success",
                                                    type: "button",
                                                    onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (updateShift()), ["stop"])),
                                                    disabled: inProcess.value || !!error.value,
                                                    "data-qa": "shift-control-button-update-shift"
                                                  }, [
                                                    _createVNode(VitaIcon, { name: "checked" })
                                                  ], 8, _hoisted_25)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 10, _hoisted_20),
                                          _createElementVNode("div", _hoisted_26, [
                                            (updatingOpenId.value && updatingOpenId.value === item.id)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                  _createElementVNode("div", {
                                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (closeUpdatingItem())),
                                                    class: "d-flex close",
                                                    "data-qa": "shift-control-icon-edit-cancel"
                                                  }, [
                                                    _createVNode(VitaIcon, { name: "cross-dark" })
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (canOpenShiftMenu(item))
                                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                (!isWFMReaderRole.value && item.zupGuid)
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 0,
                                                      onClick: ($event: any) => (openShiftMenu(item)),
                                                      class: "shift__menu-icon",
                                                      "data-qa": "shift-control-icon-menu-open"
                                                    }, [
                                                      _createVNode(VitaIcon, { name: "kebab-menu" })
                                                    ], 8, _hoisted_29))
                                                  : _createCommentVNode("", true),
                                                (menuOpenId.value === item.id)
                                                  ? (_openBlock(), _createBlock(VitaShiftMenuDialog, {
                                                      key: 1,
                                                      position: __props.position,
                                                      "can-delete": isDeleteShiftAvailable(item),
                                                      "can-update": isUpdateShiftAvailable(item),
                                                      "can-copy": Boolean(isCopyShiftAvailable(item)),
                                                      "can-info": Boolean(isInfoShiftAvailable(item)),
                                                      disabled: inProcess.value,
                                                      onDelete: ($event: any) => (openDeleteModal(item)),
                                                      onUpdate: ($event: any) => (onUpdateShiftClick(item)),
                                                      onCopy: ($event: any) => (onCopyShiftClick(item)),
                                                      onInfo: ($event: any) => (onInfoShiftClick(item))
                                                    }, null, 8, ["position", "can-delete", "can-update", "can-copy", "can-info", "disabled", "onDelete", "onUpdate", "onCopy", "onInfo"]))
                                                  : _createCommentVNode("", true)
                                              ])), [
                                                [_directive_click_outside_element, () => closeShiftMenu(item)]
                                              ])
                                            : _createCommentVNode("", true)
                                        ], 2)
                                      ]),
                                      (
                    (item.diner && !updatingOpenId.value) ||
                    (item.diner && updatingOpenId.value && updatingOpenId.value !== item.id)
                  )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                            _createVNode(VitaIcon, {
                                              name: "cup",
                                              class: "icon"
                                            }),
                                            _cache[22] || (_cache[22] = _createElementVNode("div", null, "Перерыв:", -1)),
                                            _createElementVNode("div", null, _toDisplayString(item.diner), 1)
                                          ]))
                                        : (dinerTime.value && updatingOpenId.value && updatingOpenId.value === item.id)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                              _createVNode(VitaIcon, {
                                                name: "cup",
                                                class: "icon"
                                              }),
                                              _cache[23] || (_cache[23] = _createElementVNode("div", null, "Перерыв:", -1)),
                                              _createElementVNode("div", null, _toDisplayString(dinerTime.value), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                      (error.value && updatingOpenId.value && updatingOpenId.value === item.id)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(error.value), 1))
                                        : _createCommentVNode("", true),
                                      (__props.user.timeShift && item.status === 'Miss')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                            _createElementVNode("button", {
                                              class: _normalizeClass(["button btn-toggle", { 'btn-toggle-open': openedMissSpoiler.value }]),
                                              type: "button",
                                              onClick: ($event: any) => (openMissSpoiler(item)),
                                              "data-qa": "shift-control-button-miss-toggle"
                                            }, [
                                              _cache[24] || (_cache[24] = _createElementVNode("span", null, "Сотрудник уведомил о невыходе", -1)),
                                              _createVNode(VitaIcon, { name: "chevron-down" })
                                            ], 10, _hoisted_34),
                                            (openedMissSpoiler.value)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                  _createElementVNode("div", _hoisted_36, [
                                                    (__props.user.timeShift[__props.date][0].cancelationReason)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                          _cache[25] || (_cache[25] = _createElementVNode("div", null, "Причина", -1)),
                                                          _createElementVNode("div", null, _toDisplayString(__props.user.timeShift[__props.date][0].cancelationReason), 1)
                                                        ]))
                                                      : _createCommentVNode("", true),
                                                    (__props.user.timeShift[__props.date][0].cancelationComment)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                          _cache[26] || (_cache[26] = _createElementVNode("div", null, "Комментарий", -1)),
                                                          _createVNode(_unref(PerfectScrollbar), {
                                                            class: "scroll-comment",
                                                            options: { wheelPropagation: false, suppressScrollX: true }
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("div", _hoisted_39, _toDisplayString(__props.user.timeShift[__props.date][0].cancelationComment), 1)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 10, _hoisted_17))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["id"])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createBlock(VitaVacationControl, {
                        key: 2,
                        date: __props.date,
                        "zup-guid": __props.user.zupGuid,
                        "timezone-offset": timezoneOffset.value,
                        "pharm-id": pharmId.value,
                        "update-id": activeVacationUpdate.value,
                        visible: activeVacationChange.value,
                        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((activeVacationChange).value = $event))
                      }, null, 8, ["date", "zup-guid", "timezone-offset", "pharm-id", "update-id", "visible"]))
                ]))
              : _createCommentVNode("", true),
            _createVNode(VitaIcon, {
              class: "shift__tri",
              name: "tri"
            })
          ]),
          (__props.text)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, _toDisplayString(__props.text), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(VitaInfoModal, {
      open: shiftInfoModal.value.open,
      onToggleInfoModal: closeShiftInfoModal,
      title: "Информация о смене",
      "modal-icon": "pencil-edit",
      "modal-size": "medium-wide"
    }, {
      default: _withCtx(() => [
        _createVNode(VitaShiftInfo, {
          "shift-id": shiftInfoId.value,
          timeShift: __props.user.timeShift && __props.user.timeShift[__props.date]
        }, null, 8, ["shift-id", "timeShift"])
      ]),
      _: 1
    }, 8, ["open"]),
    (openModal.value)
      ? (_openBlock(), _createBlock(_component_vita_modal, {
          key: 1,
          title: "Вы действительно хотите удалить смену?"
        }, {
          default: _withCtx(() => [
            _createVNode(VitaButton, {
              color: "red",
              width: "inline",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (deleteShift($event))),
              disabled: inProcess.value,
              "data-qa": "shift-control-button-delete-confirm"
            }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                _createTextVNode("Да", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(VitaButton, {
              color: "blue",
              width: "inline",
              onClick: onShiftDeleteCancel,
              disabled: inProcess.value,
              "data-qa": "shift-control-button-delete-cancel"
            }, {
              default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                _createTextVNode("Нет", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (openConfirmModal.value)
      ? (_openBlock(), _createBlock(_component_vita_modal, {
          key: 2,
          title: "Вы уверены, что хотите отменить проставление НН?"
        }, {
          default: _withCtx(() => [
            _createVNode(VitaButton, {
              color: "red",
              width: "inline",
              onClick: closeVacationEdit,
              disabled: inProcess.value,
              "data-qa": "shift-control-button-vacation-cancel-confirm"
            }, {
              default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                _createTextVNode("Да", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(VitaButton, {
              color: "blue",
              width: "inline",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (openConfirmModal.value = false)),
              disabled: inProcess.value,
              "data-qa": "shift-control-button-vacation-cancel-reject"
            }, {
              default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                _createTextVNode("Нет", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})